export { default as OpeningLayout } from './layout';

export type { OpeningLayoutProps } from './layout';
